import PropTypes from 'prop-types';
import React from 'react';

import { formatSizeInMB } from 'common-src/utils/fileUtils';

import styles from './FileInput.module.scss';

const FileInput = ({
  id,
  value,
  errorText,
  placeholder,
  inputAccept,
  description,
  handleFileChange,
}) => (
  <div id={id}>
    <label htmlFor="file-input" className={[styles.label, 'cursor-pointer'].join(' ')}>
      <div className={[styles.wrapper, 'secondary-border', 'border-r-6', 'p-30'].join(' ')}>
        <div className={['flex-column', 'vertically-centered', 'gap-8'].join(' ')}>
          <span className={['font-s-28', 'm-b-8'].join(' ')}>📄</span>
          <span className={['font-s-16', 'font-w-500'].join(' ')}>
            {value?.name ? `${value.name} (${formatSizeInMB(value.size)})` : placeholder}
          </span>
          <span className={['font-s-12'].join(' ')}>
            {value?.name ? 'Click to change file' : description}
          </span>
        </div>
      </div>
    </label>
    <input
      id="file-input"
      type="file"
      accept={inputAccept}
      onChange={handleFileChange}
      className={styles.fileInput}
    />
    <span className={[styles.error, 'font-w-400', 'font-s-12'].join(' ')}>{errorText}</span>
  </div>
);

export default FileInput;

FileInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.object,
  errorText: PropTypes.string,
  placeholder: PropTypes.string,
  inputAccept: PropTypes.string,
  description: PropTypes.string,
  handleFileChange: PropTypes.func,
};
